import { gql } from "apollo-boost";

export const fragments = {
  job: gql`
    fragment JobQueryJob on Job {
      id
      contractNumber
      contractType
      primaryContractId
      archived
      contact {
        id
        firstName
        lastName
        otherFirstName
        otherLastName
      }
      franchise {
        id
        name
        assignedInHouseTty
      }
    }
  `
};

export default gql`
  query JobQuery($jobId: Int!) {
    job(id: $jobId) {
      ...JobQueryJob
    }
  }
  ${fragments.job}
`;



// WEBPACK FOOTER //
// ./src/queries/Job.js